import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { IonAccordionGroup } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ProductModel } from "src/app/models/product.model";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { DataService } from "src/app/services/data/data.service";
import { ProductService } from "src/app/services/product/product.service";



@Component({
  selector: "filter-panel",
  templateUrl: "./filter-panel.component.html",
  styleUrls: ["./filter-panel.component.scss"]
})
export class FilterPanelComponent implements OnInit {

  @Input()
  items: any[];

  @Input()
  sortBy: string = 'abc';

  @Input()
  producers:ProfileModel[];

  @Input()
  showSearch: false;

  @Input()
  mode: 'compact';

  keyword:string;
  @Input("products")
  set products(value: any) {
    this.items = this.buildFilterFromProducts(value);
    this.itemsFiltered = this.itemsToArray(Array.from(this.items));
    // console.log(this.items);
  }


  @Input("productsByType")
  set productsByType(value: any) {
    this.items = this.buildFilter(value);
    this.itemsToArray(Array.from(this.items));
  }

  @Input("tourneesArray")
  set tourneesArray(value: TourneeModel[]) {
    this.items = this.buildFilter(this.productService.sortAndTransformTourneesIntoProductListArrayByType(value));
    this.itemsToArray(Array.from(this.items));
  }

  @Output() sorted = new EventEmitter<any>();
  @Output() filtered = new EventEmitter<any>();
  @Output() producerClicked = new EventEmitter<any>();
  @Output() searched = new EventEmitter<any>();
  @Output() filteredAndSearched = new EventEmitter<any>();

  typeFilterArray = [{name:"vegetable-producer", status:false},{name:"fruit-producer",status:false},{name:"butcher",status:false},
  {name:"poultry",status:false},{name:"fisherman",status:false},{name:"baker",status:false},{name:"miller",status:false},
  {name:"egger",status:false},{name:"dairy",status:false},{name:"cheese-maker",status:false},{name:"beekeeper",status:false},
  {name:"wine-maker",status:false},{name:"brewery",status:false},{name:"snack",status:false},{name:"biscuit",status:false},
  {name:"can",status:false},{name:"ice-cream",status:false},{name:"yogurt",status:false},{name:"condiment",status:false},
  {name:"jam",status:false},{name:"oil",status:false},{name:"restaurant",status:false},{name:"cosmetic",status:false},{name:"flower",status:false}];
  
  itemsFiltered = [];

  @ViewChild('accordionGroup', { static: true }) accordionGroup: IonAccordionGroup;


  constructor(private dataService:DataService, private productService:ProductService, private translateService:TranslateService) {
  }

  ngOnInit(): void {}

  onClick(item){
    item.status = !item.status;

    this.itemsFiltered = this.items.filter(item => {
      return item.status
    }).map(item => item.name);
    if(this.itemsFiltered.length == 0){
      this.itemsFiltered = this.itemsToArray(Array.from(this.items));
    }
    this.filtered.emit(this.itemsFiltered);
    const filter = {
      keyword:this.keyword,
      types: this.itemsFiltered
    }
    this.filteredAndSearched.emit(filter);
  }

  closeAllAccordions = () => {
    const nativeEl = this.accordionGroup;
    nativeEl.value = undefined;
  };

  onProducerClicked(producer:ProfileModel){
    this.producerClicked.emit(producer);
    this.closeAllAccordions();
  }

  onInputChange(event){
    this.keyword = event.detail.value;
    this.searched.emit(event.detail.value);
    const filter = {
      keyword:event.detail.value,
      types: this.itemsFiltered
    }
    this.filteredAndSearched.emit(filter);
  }

  buildFilter(productTypes:any){
    return (Object.entries(productTypes) as any[]).map(item=><any>{
      name:item[0], nameTranslated:item[1].nameTranslated ,status:false, quantity:item[1].array.length
    }).sort(this.sortTypes);
  }

  itemsToArray(items:any[]){
    return items.map(item=>item.name);
  }

  buildFilterFromProducts(products:ProductModel[]){
    const translateService = this.translateService;
    const reducer = function (accumulator:any, currentValue:ProductModel) {   
      // console.log(currentValue, accumulator);     
      const type = currentValue.details.type;
      if (type in accumulator) {
        accumulator[type].quantity +=1;
      } else {
        accumulator[type] = { name:type, nameTranslated: translateService.instant('product.types.'+type),status:false, quantity:1 };
      }
      return accumulator;
    };
    return (Object.values(products.reduce(reducer, {})) as any[]).sort(this.sortTypes);
  }

  sortTypes(a,b) {
    if (a.nameTranslated < b.nameTranslated) {
      return -1;
    }
    if (a.nameTranslated > b.nameTranslated) {
      return 1;
    }
    return 0;
  }

  onSwitchSorting(sort:string){
    this.sortBy = sort;
    this.sorted.emit(sort);
  }

}
